var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentStatusChanged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91602 0.583008L11.2493 2.91634L8.91602 5.24967",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.41699V5.25033C0.75 4.63149 0.995833 4.03799 1.43342 3.60041C1.871 3.16282 2.46449 2.91699 3.08333 2.91699H11.25",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08333 13.4167L0.75 11.0833L3.08333 8.75",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.58301V8.74967C11.25 9.36851 11.0042 9.96201 10.5666 10.3996C10.129 10.8372 9.5355 11.083 8.91667 11.083H0.75",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusChanged);
export default __webpack_public_path__ + "static/media/payment_status_changed.c0b7b9d1.svg";
export { ForwardRef as ReactComponent };